import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import dayjs from 'dayjs';
import { UKCountryList } from '../../constants/quote';
import { PartnerType, SubBrokerType } from '../../shared/generated';
import { trimText } from '../../utils/text';
import { convertTimeToServerStoredTimeDataWithZeroTime } from '../../utils/time';
export var convertLocalBrokerDetailDataToServerStructureData = function convertLocalBrokerDetailDataToServerStructureData(brokerId, data) {
  var _ref = data || {},
      legalEntityCountry = _ref.legalEntityCountry,
      legalEntityName = _ref.legalEntityName,
      insuranceLicenseNumber = _ref.insuranceLicenseNumber,
      companyNumber = _ref.companyNumber,
      companyOfficeId = _ref.companyOfficeId,
      taxNumber = _ref.taxNumber,
      streetAddress = _ref.streetAddress,
      houseNumber = _ref.houseNumber,
      flatNumber = _ref.flatNumber,
      zipCode = _ref.zipCode,
      city = _ref.city,
      contactFirstName = _ref.contactFirstName,
      contactLastName = _ref.contactLastName,
      contactJobTitle = _ref.contactJobTitle,
      contactEmail = _ref.contactEmail,
      contactPhone = _ref.contactPhone,
      isTheSigner = _ref.isTheSigner,
      signUserFirstName = _ref.signUserFirstName,
      signUserLastName = _ref.signUserLastName,
      signUserJobTitle = _ref.signUserJobTitle,
      signUserEmail = _ref.signUserEmail,
      signUserPhone = _ref.signUserPhone,
      operateCountries = _ref.operateCountries,
      countryBrokerId = _ref.countryBrokerId,
      brokerPlatform = _ref.brokerPlatform,
      fcaLicenseNumber = _ref.fcaLicenseNumber,
      confirmPassport = _ref.confirmPassport,
      signUserInviteMessage = _ref.signUserInviteMessage,
      signUserSignature = _ref.signUserSignature,
      regulatedBodyName = _ref.regulatedBodyName,
      acturisActivated = _ref.acturisActivated,
      brokerCommission = _ref.brokerCommission,
      brokerCommissionUnit = _ref.brokerCommissionUnit,
      brokerFee = _ref.brokerFee,
      brokerFeeUnit = _ref.brokerFeeUnit,
      payload = _ref.payload,
      parentLegalEntity = _ref.parentLegalEntity,
      skipSetCommission = _ref.skipSetCommission,
      allowDirectPayWithoutRules = _ref.allowDirectPayWithoutRules,
      partnerEntityType = _ref.partnerEntityType,
      commissionRateEffectiveDate = _ref.commissionRateEffectiveDate,
      applyCommissionFromInception = _ref.applyCommissionFromInception;

  var productFeeConfig = {
    broker_commission_fee: brokerCommission,
    broker_commission_fee_type: brokerCommissionUnit
  };

  if (partnerEntityType === PartnerType.GENERAL) {
    productFeeConfig.broker_fee = brokerFee;
    productFeeConfig.broker_fee_type = brokerFeeUnit;
  }

  var params = {
    broker_id: brokerId,
    country_code: legalEntityCountry === null || legalEntityCountry === void 0 ? void 0 : legalEntityCountry.code,
    name: trimText(legalEntityName),
    insurance_license_number: insuranceLicenseNumber,
    company_number: companyNumber,
    company_office_id: trimText(companyOfficeId),
    tax_number: taxNumber,
    street_address: streetAddress,
    house_number: houseNumber,
    flat_number: flatNumber,
    post_code: zipCode,
    city: city,
    contact_first_name: contactFirstName,
    contact_last_name: contactLastName,
    contact_job_title: contactJobTitle,
    contact_email: contactEmail,
    contact_phone: contactPhone,
    is_signatory: !!isTheSigner,
    signatory_first_name: signUserFirstName || null,
    signatory_last_name: signUserLastName || null,
    signatory_job_title: signUserJobTitle || null,
    signatory_email: signUserEmail || null,
    signatory_phone: signUserPhone || null,
    invite_message: signUserInviteMessage || null,
    eu_pass_porting: confirmPassport,
    signatory_signature_message: signUserSignature || null,
    platform: brokerPlatform,
    regulated_body_name: UKCountryList.includes(legalEntityCountry === null || legalEntityCountry === void 0 ? void 0 : legalEntityCountry.code) ? 'Financial Conduct Authority' : regulatedBodyName,
    acturis_activated: acturisActivated,
    payload: _objectSpread(_objectSpread({}, payload), {}, {
      product_fee_config: productFeeConfig,
      skip_set_commission: skipSetCommission,
      allow_direct_pay_without_rules: !!allowDirectPayWithoutRules,
      commission_rate_effective_date: applyCommissionFromInception ? null : convertTimeToServerStoredTimeDataWithZeroTime(commissionRateEffectiveDate),
      apply_commission_from_inception: !!applyCommissionFromInception
    }),
    sub_broker_type: partnerEntityType === PartnerType.GENERAL ? SubBrokerType.PARTNER : SubBrokerType.BROKER
  };

  if (UKCountryList.includes(legalEntityCountry === null || legalEntityCountry === void 0 ? void 0 : legalEntityCountry.code)) {
    params.broker_registration_id = trimText(countryBrokerId);
    params.platform = brokerPlatform;
    params.insurance_license_number = trimText(fcaLicenseNumber);
  } else {
    params.allowed_eu_country = operateCountries.map(function (item) {
      return item.value;
    });
    params.insurance_license_number = trimText(insuranceLicenseNumber);
  }

  if (parentLegalEntity) {
    params.parent_id = parentLegalEntity;
  }

  return params;
};
export var convertLocalBrokerActivityRecordWithKeyDataToServerStructureData = function convertLocalBrokerActivityRecordWithKeyDataToServerStructureData(key, data) {
  switch (key) {
    case 'demo':
      return convertLocalBrokerActivityRecordDemoDataToServerStructureData(data);

    case 'onboarding_process_workflow':
      return convertLocalBrokerActivityRecordOnboardingDataToServerStructureData(data);

    case 'online_training':
      return convertLocalBrokerActivityRecordOnlineTrainingDataToServerStructureData(data);

    case 'in_person_training':
      return convertLocalBrokerActivityRecordInPersonTrainingDataToServerStructureData(data);

    default:
      return {};
  }
};
export var convertLocalBrokerActivityRecordDemoDataToServerStructureData = function convertLocalBrokerActivityRecordDemoDataToServerStructureData(data) {
  var _ref3, _brokerDemoResponsibl;

  var _ref2 = data || {},
      demoBookedDate = _ref2.demoBookedDate,
      demoTime = _ref2.demoTime,
      demoBookedBy = _ref2.demoBookedBy,
      brokerDemoResponsiblePerson = _ref2.brokerDemoResponsiblePerson,
      demoStatus = _ref2.demoStatus,
      demoOutcome = _ref2.demoOutcome,
      demoFollowUpAction = _ref2.demoFollowUpAction,
      demoNotes = _ref2.demoNotes,
      demoAttendees = _ref2.demoAttendees;

  return {
    demo_booked_date: demoBookedDate ? dayjs(demoBookedDate).format('YYYY-MM-DD') : null,
    demo_time: demoTime ? dayjs(demoTime).format('HH:mm') : null,
    demo_booked_by: demoBookedBy || '',
    broker_demo_responsible_person_user_id: (_ref3 = (_brokerDemoResponsibl = brokerDemoResponsiblePerson === null || brokerDemoResponsiblePerson === void 0 ? void 0 : brokerDemoResponsiblePerson.value) !== null && _brokerDemoResponsibl !== void 0 ? _brokerDemoResponsibl : brokerDemoResponsiblePerson) !== null && _ref3 !== void 0 ? _ref3 : null,
    demo_status: demoStatus || '',
    demo_outcome: demoOutcome || '',
    demo_follow_up_action: demoFollowUpAction || '',
    demo_notes: demoNotes || '',
    demo_attendees: demoAttendees || ''
  };
};
export var convertLocalBrokerActivityRecordOnboardingDataToServerStructureData = function convertLocalBrokerActivityRecordOnboardingDataToServerStructureData(data) {
  var _ref5, _originationManager$v, _ref6, _activationManager$va, _ref7, _miscMeetingResponsib;

  var _ref4 = data || {},
      originationManager = _ref4.originationManager,
      activationManager = _ref4.activationManager,
      miscMeetingDate = _ref4.miscMeetingDate,
      miscMeetingTime = _ref4.miscMeetingTime,
      miscMeetingStatus = _ref4.miscMeetingStatus,
      miscMeetingResponsiblePerson = _ref4.miscMeetingResponsiblePerson,
      miscMeetingNotes = _ref4.miscMeetingNotes,
      agreementStatus = _ref4.agreementStatus,
      agreementSignedDate = _ref4.agreementSignedDate,
      onboardingStatus = _ref4.onboardingStatus,
      onboardingCompletedDate = _ref4.onboardingCompletedDate,
      brokerStartDate = _ref4.brokerStartDate,
      brokerStatus = _ref4.brokerStatus,
      brokerType = _ref4.brokerType,
      portalAccessStatus = _ref4.portalAccessStatus,
      portalAccessActivatedDate = _ref4.portalAccessActivatedDate,
      numberOfPortalUsers = _ref4.numberOfPortalUsers,
      preferredTrainingFormat = _ref4.preferredTrainingFormat,
      trainingContact = _ref4.trainingContact,
      commissionAgreed = _ref4.commissionAgreed,
      paymentArrangement = _ref4.paymentArrangement,
      whiteLabelledRequired = _ref4.whiteLabelledRequired,
      brokerNotes = _ref4.brokerNotes;

  return {
    origination_manager_user_id: (_ref5 = (_originationManager$v = originationManager === null || originationManager === void 0 ? void 0 : originationManager.value) !== null && _originationManager$v !== void 0 ? _originationManager$v : originationManager) !== null && _ref5 !== void 0 ? _ref5 : undefined,
    activation_manager_user_id: (_ref6 = (_activationManager$va = activationManager === null || activationManager === void 0 ? void 0 : activationManager.value) !== null && _activationManager$va !== void 0 ? _activationManager$va : activationManager) !== null && _ref6 !== void 0 ? _ref6 : undefined,
    miscellaneous_meeting_date: miscMeetingDate ? dayjs(miscMeetingDate).format('YYYY-MM-DD') : undefined,
    miscellaneous_meeting_time: miscMeetingTime ? dayjs(miscMeetingTime).format('HH:mm') : undefined,
    miscellaneous_meeting_status: miscMeetingStatus || undefined,
    miscellaneous_meeting_responsible_person_user_id: (_ref7 = (_miscMeetingResponsib = miscMeetingResponsiblePerson === null || miscMeetingResponsiblePerson === void 0 ? void 0 : miscMeetingResponsiblePerson.value) !== null && _miscMeetingResponsib !== void 0 ? _miscMeetingResponsib : miscMeetingResponsiblePerson) !== null && _ref7 !== void 0 ? _ref7 : undefined,
    miscellaneous_meeting_notes: miscMeetingNotes || undefined,
    agreement_status: agreementStatus || undefined,
    agreement_signed_date: agreementSignedDate ? dayjs(agreementSignedDate).format('YYYY-MM-DD') : undefined,
    onboarding_status: onboardingStatus || undefined,
    onboarding_completed_date: onboardingCompletedDate ? dayjs(onboardingCompletedDate).format('YYYY-MM-DD') : undefined,
    broker_start_date: brokerStartDate ? dayjs(brokerStartDate).format('YYYY-MM-DD') : undefined,
    broker_status: brokerStatus || undefined,
    broker_type: brokerType || undefined,
    portal_access_status: portalAccessStatus || undefined,
    portal_access_activated_date: portalAccessActivatedDate ? dayjs(portalAccessActivatedDate).format('YYYY-MM-DD') : undefined,
    number_of_portal_users: numberOfPortalUsers !== null && numberOfPortalUsers !== void 0 ? numberOfPortalUsers : undefined,
    preferred_training_format: preferredTrainingFormat || undefined,
    training_contact: trainingContact || undefined,
    commission_agreed: commissionAgreed !== null && commissionAgreed !== void 0 ? commissionAgreed : undefined,
    payment_arrangement: paymentArrangement || undefined,
    white_labelled_required: whiteLabelledRequired !== null && whiteLabelledRequired !== void 0 ? whiteLabelledRequired : undefined,
    broker_notes: brokerNotes || undefined
  };
};
export var convertLocalBrokerActivityRecordOnlineTrainingDataToServerStructureData = function convertLocalBrokerActivityRecordOnlineTrainingDataToServerStructureData(data) {
  var _ref9, _onlineMeetingRespons;

  var _ref8 = data || {},
      onlineTrainingBookedDate = _ref8.onlineTrainingBookedDate,
      onlineMeetingResponsiblePerson = _ref8.onlineMeetingResponsiblePerson,
      onlineTrainingDate = _ref8.onlineTrainingDate,
      onlineTrainingTime = _ref8.onlineTrainingTime,
      onlineTrainingStatus = _ref8.onlineTrainingStatus,
      onlineTrainingOutcome = _ref8.onlineTrainingOutcome,
      onlineTrainingNotes = _ref8.onlineTrainingNotes,
      onlineTrainingMaterialsRequired = _ref8.onlineTrainingMaterialsRequired,
      onlineTrainingMaterialsSent = _ref8.onlineTrainingMaterialsSent;

  return {
    online_training_booked_date: onlineTrainingBookedDate ? dayjs(onlineTrainingBookedDate).format('YYYY-MM-DD') : undefined,
    online_meeting_responsible_person_user_id: (_ref9 = (_onlineMeetingRespons = onlineMeetingResponsiblePerson === null || onlineMeetingResponsiblePerson === void 0 ? void 0 : onlineMeetingResponsiblePerson.value) !== null && _onlineMeetingRespons !== void 0 ? _onlineMeetingRespons : onlineMeetingResponsiblePerson) !== null && _ref9 !== void 0 ? _ref9 : undefined,
    online_training_date: onlineTrainingDate ? dayjs(onlineTrainingDate).format('YYYY-MM-DD') : undefined,
    online_training_time: onlineTrainingTime ? dayjs(onlineTrainingTime).format('HH:mm') : undefined,
    online_training_status: onlineTrainingStatus || undefined,
    online_training_outcome: onlineTrainingOutcome || undefined,
    online_training_notes: onlineTrainingNotes || undefined,
    online_training_materials_required: onlineTrainingMaterialsRequired !== null && onlineTrainingMaterialsRequired !== void 0 ? onlineTrainingMaterialsRequired : undefined,
    online_training_materials_sent: onlineTrainingMaterialsSent !== null && onlineTrainingMaterialsSent !== void 0 ? onlineTrainingMaterialsSent : undefined
  };
};
export var convertLocalBrokerActivityRecordInPersonTrainingDataToServerStructureData = function convertLocalBrokerActivityRecordInPersonTrainingDataToServerStructureData(data) {
  var _ref11, _inPersonTrainingResp;

  var _ref10 = data || {},
      inPersonTrainingResponsiblePerson = _ref10.inPersonTrainingResponsiblePerson,
      inPersonTrainingBookedDate = _ref10.inPersonTrainingBookedDate,
      inPersonTrainingDate = _ref10.inPersonTrainingDate,
      inPersonTrainingStatus = _ref10.inPersonTrainingStatus,
      inPersonTrainingOutcome = _ref10.inPersonTrainingOutcome,
      inPersonTrainingNotes = _ref10.inPersonTrainingNotes,
      inPersonTrainingMaterialsRequired = _ref10.inPersonTrainingMaterialsRequired,
      inPersonTrainingMaterialsSent = _ref10.inPersonTrainingMaterialsSent;

  return {
    in_person_training_responsible_person_user_id: (_ref11 = (_inPersonTrainingResp = inPersonTrainingResponsiblePerson === null || inPersonTrainingResponsiblePerson === void 0 ? void 0 : inPersonTrainingResponsiblePerson.value) !== null && _inPersonTrainingResp !== void 0 ? _inPersonTrainingResp : inPersonTrainingResponsiblePerson) !== null && _ref11 !== void 0 ? _ref11 : undefined,
    in_person_training_booked_date: inPersonTrainingBookedDate ? dayjs(inPersonTrainingBookedDate).format('YYYY-MM-DD') : undefined,
    in_person_training_date: inPersonTrainingDate ? dayjs(inPersonTrainingDate).format('YYYY-MM-DD') : undefined,
    in_person_training_status: inPersonTrainingStatus || undefined,
    in_person_training_outcome: inPersonTrainingOutcome || undefined,
    in_person_training_notes: inPersonTrainingNotes || undefined,
    training_material_required: inPersonTrainingMaterialsRequired !== null && inPersonTrainingMaterialsRequired !== void 0 ? inPersonTrainingMaterialsRequired : undefined,
    training_material_sent: inPersonTrainingMaterialsSent !== null && inPersonTrainingMaterialsSent !== void 0 ? inPersonTrainingMaterialsSent : undefined
  };
};